import styled from 'styled-components';
import { Table as BaseTable } from 'antd';

export const StyledTable = styled(BaseTable)`
  && {
    /* Células do cabeçalho */
    .ant-table-thead > tr > th {
      font-family: 'Montserrat', sans-serif;
      background-color: #2b97be;
      color: white;
      font-size: 14px;
      font-weight: bold;
      text-align: center;
      justify-content: center;
      border: none;
    }

    /* Impede alteração da cor de fundo no hover, inclusive em colunas com ordenação */
    .ant-table-thead > tr > th:hover {
      background-color: #2b97be !important;
    }

    /* Linhas (rows) */
    .ant-table-tbody > tr > td {
      font-family: 'Montserrat', sans-serif;
      min-height: 48px;
      background-color: transparent;
      border: 1px solid #dee2e6;
    }
    
    .ant-table-tbody > tr:nth-of-type(odd) {
      background-color: #f2f2f2;
    }
    
    .ant-table-tbody > tr:nth-of-type(even) {
      background-color: #f9fafb;
    }

    /* Células (cells) */
    .ant-table-tbody > tr > td {
      color: #333;
      text-align: center;
      justify-content: center;
      padding: 8px;
    }

    /* Paginação */
    .ant-pagination {
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 8px 0;
      background-color: transparent;
    }
  }
`;
